// import { create } from "zustand";
// import { persist } from "zustand/middleware";
// import { immer } from "zustand/middleware/immer";

import { createStore } from "../../Boilerplate/NBoilerplateContext";
import { setGlobalStoreInstance } from "../../Boilerplate/store";

// App-specific slice
const applyList = (current, next) =>
  typeof next === "function" ? next(current) : next;

const createImportsSlice = (set, get) => ({
  imports: null,
  setImports: (imports) =>
    set((state) => ({ imports: applyList(state.imports, imports) })),
  importsDomestic: null,
  setImportsDomestic: (importsDomestic) =>
    set((state) => ({
      importsDomestic: applyList(state.importsDomestic, importsDomestic),
    })),
  importsAsin: null,
  setImportsAsin: (importsAsin) =>
    set((state) => ({ importsAsin: applyList(state.importsAsin, importsAsin) })),
});

export const store = createStore({ 
  name: "optivise",
  appState: createImportsSlice
});

setGlobalStoreInstance(store); // Set it globally for non-React code

export const useStore = store;

// export const useStore = create(
//   persist(
//     immer((set, get) => ({
//       imports: null,
//       setImports: (imports) => set(() => ({ imports })),
//       importsDomestic: null,
//       setImportsDomestic: (importsDomestic) => set(() => ({ importsDomestic })),
//       importsAsin: null,
//       setImportsAsin: (importsAsin) => set(() => ({ importsAsin })),
//     }))
//   )
// );
